import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";

const AuthForms: React.FC = () => {
  const { t } = useTranslation();
  const [view, setView] = useState<"login" | "register">("login");

  return (
    <div className="auth-forms-container">
      <div className="auth-card">
        {/* Navigation Tabs */}
        <div className="auth-card__tabs">
          <button
            className={`auth-card__tab ${view === "login" ? "is-active" : ""}`}
            onClick={() => setView("login")}
            type="button"
          >
            {t("user.auth.loginTab")}
          </button>
          <button
            className={`auth-card__tab ${
              view === "register" ? "is-active" : ""
            }`}
            onClick={() => setView("register")}
            type="button"
          >
            {t("user.auth.registerTab")}
          </button>
        </div>

        {/* Conditional Content Rendering */}
        <div className="auth-card__content">
          {view === "login" ? <LoginForm /> : <RegisterForm />}
        </div>
      </div>
    </div>
  );
};

export default AuthForms;
